import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import SearchForm from "../../../../component/search-form";
import { sanitizeInput } from "../../../../utils";
import useDebounce from "../../../../Hook/useDebounce";
import ProductInventoryTable from "./ProductInventoryTable";
import { useDispatch, useSelector } from "react-redux";
import { getAllProductDataList } from "../../../../redux/actions/productMaster";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import {
  addInventoryTableLayout,
  getInventoryTableLayout,
} from "../../../../redux/actions/inventory";

function ProductInventoryIndex() {
  // Constant
  const viewOptions = [
    { label: "Week View", value: "week" },
    { label: "Day View", value: "day" },
    { label: "Month View", value: "month" },
  ];

  // State
  const [searchText, setSearchText] = useState();
  const [productOption, setProductOption] = useState([]);
  const [productFilterValue, setProductFilterValue] = useState();
  const [tableView, setTableView] = useState(viewOptions[0]);
  const [simulationModeOn, setSimulationModeOn] = useState(false);
  const [page, setPage] = useState(1);
  const [productTableLayout, setProductTableLayout] = useState([])

  // Redux
  const dispatch = useDispatch();
  const { allProductData } = useSelector((state) => state.productMaster);

  const debouncedHandleSearch = useDebounce(searchText, 300);
  const debounceProductFilter = useDebounce(productFilterValue, 300);

  // Function to GET all SKU data for filter option
  const getProductList = () => {
    const request = {
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={error?.message}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAllProductDataList(request));
  };

  // Function to GET Inventory Table Layout
  const getProductTableLayout = () => {
    const request = {
      type: "product",
      onSuccess: (data) => {
        setProductTableLayout(data)
      },
      onError: (err) => {},
    };
    dispatch(getInventoryTableLayout(request));
  };

  // Function to ADD Inventory Table Layout
  const addProductTableLayout = (tableLayoutPayload) => {
    const request = {
      payload: {
        type: "product",
        items: tableLayoutPayload,
      },
      onError: (error) => {},
    };
    // console.log("product table layout ==", request.payload);
    dispatch(addInventoryTableLayout(request));
  };

  useEffect(() => {
    getProductList();
    getProductTableLayout();
  }, []);

  useEffect(() => {
    if (allProductData.length > 0) {
      setProductOption(
        allProductData.map((element) => {
          const obj = {
            label: element.product_name,
            value: element.product_master_id,
          };
          return obj;
        })
      );
    }
  }, [allProductData]);

  useEffect(() => {
    if (productTableLayout.length > 0 && allProductData.length > 0) {
      setProductFilterValue(
        productTableLayout.map((item) => {
          const filterOption = allProductData.find(
            (element) => element?.product_master_id === item?.sku_or_product_id
          );
          console.log({
            filterOption,
            allProductData,
            productTableLayout,
          });
          const obj = {
            label: filterOption?.product_name,
            value: filterOption?.product_master_id,
            inventory_table_layout_id: item?.inventory_table_layout_id,
          };
          return obj;
        })
      );
    }
  }, [productTableLayout, allProductData]);

  useEffect(() => {
    if (debounceProductFilter) {
      const tableLayoutPayload = debounceProductFilter.map((item, index) => {
        const obj = {
          type: "product",
          sku_or_product_id: item.value,
          sequence: index + 1,
        };
        if (item?.inventory_table_layout_id) {
          obj.inventory_table_layout_id = item.inventory_table_layout_id;
        }
        return obj;
      });
      addProductTableLayout(tableLayoutPayload);
    }
  }, [debounceProductFilter]);

  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      fontFamily: "inter",
      fontSize: "14px",
      padding: "3px",
      fontWeight: 600,
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+ ${length}`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 1;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  const handleChange = (selected) => {
    if (selected?.some((option) => option?.value === "all")) {
      if (productFilterValue?.length === productOption?.length) {
        setProductFilterValue([]);
      } else {
        setProductFilterValue(productOption);
      }
    } else {
      setProductFilterValue(selected || []);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            Product Inventory
          </h4>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              setSearchText(value);
            }}
            value={searchText}
          />
          <Select
            className="basic-single text-sm unresetText w-80"
            styles={{
              control: (provided) => ({
                ...provided,
                backgroundColor: "white",
                borderColor: "lightgray",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#9297A2",
                fontSize: "14px",
              }),
            }}
            classNames={{
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            onChange={(product) => {
              // setProductFilterValue(product);
              handleChange(product)
            }}
            value={productFilterValue}
            options={[{ label: "Select All", value: "all" }, ...productOption]}
            placeholder="Select Product"
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              MultiValue,
            }}
          />
        </div>

        <div className="space-x-4 flex items-center justify-end">
          <Select
            className="basic-single text-sm unresetText w-52"
            styles={{
              control: (provided) => ({
                ...provided,
                backgroundColor: "white",
                borderColor: "lightgray",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#9297A2",
                fontSize: "14px",
              }),
            }}
            classNames={{
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            onChange={(view) => {
              setTableView(view);
              setPage(1);
            }}
            value={tableView}
            options={viewOptions}
            placeholder="Select SKU"
          />
          <button
            className={`btn cursor-pointer ${
              simulationModeOn
                ? "!bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                : "bg-white border-slate-200 hover:border-slate-300 text-slate-600"
            }`}
            onClick={() => setSimulationModeOn(!simulationModeOn)}
          >
            {simulationModeOn
              ? "Back To Normal Mode"
              : "Switch To Simulation Mode"}
          </button>
        </div>
      </div>
      <ProductInventoryTable
        debouncedHandleSearch={debouncedHandleSearch}
        debounceProductFilter={debounceProductFilter}
        tableView={tableView}
        simulationModeOn={simulationModeOn}
        setPage={setPage}
        page={page}
      />
    </div>
  );
}

export default ProductInventoryIndex;
